export const styles = {
  bulkEditSummary: {
    padding: 0,
    '& .MuiTimelineItem-missingOppositeContent:before': {
      content: 'none',
    },
  },

  dotSeparator: {
    flex: 0,
  },

  fieldLabel: {
    marginBottom: 1.25,
  },
};
